module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-BoldItalic-3de51d9ab3b66d33b071694226168372.woff2";